import { validateMilitaryMember } from "@aihCustomBlueprint/Services/MilitaryValidationService";
import { AIHActions } from "@aihCustomBlueprint/Store/CustomApplicationState";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { DispatchProp } from "react-redux";


type HandlerType = ApiHandler<{code: string}
    & HasOnSuccess<string | null> 
    & HasOnError<string>, ServiceResult<string | null>, DispatchProp<AIHActions>
>;

export const ValidateMilitary: HandlerType = async props => {
    props.apiResult = await validateMilitaryMember(props.parameter.code);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [ValidateMilitary, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const validateMilitary = createHandlerChainRunner(chain, "ValidateMilitary");
export default validateMilitary;
